<template>
  <div>
    <div class="email__section">
      <div class="card">
        <div class="card-header border-bottom">
          <h4 class="card-title">Change your account's email address</h4>
        </div>
        <div class="card-body py-2 my-25">
          <div class="alert alert-danger" role="alert" v-if="errorMessage">
            {{ errorMessage }}
          </div>
          <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
          </div>
          <div class="row">
            <div class="col-sm-6 mb-1">
              <label class="form__label" for="account-old-password"
                >Current E-mail address</label
              >
              <div class="form__email">
                <input
                  type="email"
                  class="form-control input__email"
                  v-model="oldEmail"
                  :disabled="true"
                  placeholder="Enter current password"
                />
                <div class="cursor__pointer">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                </div>
              </div>
              <label class="form__label" for="account-old-password"
                >New E-mail address</label
              >
              <div class="form__email">
                <input
                  type="email"
                  class="form-control input__email"
                  v-model="newEmail"
                  placeholder="Enter current password"
                />
                <div class="cursor__pointer">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                </div>
              </div>
              <label class="form__label" for="account-old-password">
                password</label
              >
              <div class="form__email">
                <input
                  type="password"
                  class="form-control input__password"
                  v-model="password"
                  placeholder="Enter current password"
                />
                <div class="cursor__pointer" @click="showHide">
                  <i class="password_i fa fa-eye-slash" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col-12 mt-4 div__save">
                <button type="button" @click="save" class="btn btn__save">
                  Save Email Address
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Firebase, db } from "../../../firebaseDB";
import moment from "moment";

export default {
  data() {
    return {
      oldEmail: null,
      newEmail: null,
      password: null,
      errorMessage: "",
      successMessage: "",
    };
  },
  mounted() {
     db.ref().child("users/" + this.$store.state.user.id)
        .once("value").then((snapshot) => {
            let user = snapshot.val();
            this.oldEmail = user.email;
      })
  },
  methods: {
    showHide() {
      if ($(".input__password").attr("type") == "text") {
        $(".input__password").attr("type", "password");
        $(".password_i").addClass("fa-eye-slash");
        $(".password_i").removeClass("fa-eye");
      } else if ($(".input__password").attr("type") == "password") {
        $(".input__password").attr("type", "text");
        $(".password_i").removeClass("fa-eye-slash");
        $(".password_i").addClass("fa-eye");
      }
    },
    save() {
      let existed = 0;
      let updates = {};
      db.ref(`users`)
        .once("value")
        .then((snapshot) => {
          Object.keys(snapshot.val()).forEach((k) => {
            if (this.newEmail == snapshot.val()[k].email) existed += 1;
          });
          if (
            this.password === "" ||
            this.newEmail === "" ||
            this.newEmail === this.oldEmail
          ) {
            this.errorMessage =
              "Please enter password & new email address to update !";
          } else if (existed > 0) {
            this.errorMessage = "that email is already used by another user !";
          } else {
            let newEmailAddress = this.newEmail;
            let self = this;
            Firebase.auth()
              .signInWithEmailAndPassword(this.oldEmail, this.password)
              .then(function (userCredential) {
                updates["email"] = newEmailAddress;
                db.ref("users" + `/` + self.$store.state.user.id)
                  .update(updates)
                  .then((firebaseUser) => {
                    userCredential.user
                      .updateEmail(newEmailAddress)
                      .then(function () {
                        Firebase.auth()
                          .signInWithEmailAndPassword(
                            newEmailAddress,
                            self.password
                          )
                          .then((firebaseUser) => {
                            self.$store.state.user = {
                              ...self.$store.state.user,
                              id: firebaseUser.user.uid,
                            };
                            self.oldEmail =newEmailAddress
                            self.errorMessage = "";
                            self.successMessage = "Your email is updated successfully !";
                            /*db.ref(`stories`)
                                .once("value")
                                .then((snapshot) => {
                                    let updates = snapshot.val()
                                Object.keys(snapshot.val()).forEach((k) => {
                                    if (self.$store.state.user.id == snapshot.val()[k].user_id) {
                                        updates[k].author = newEmailAddress
                                    }
                                 });
                                 db.ref("stories").update(updates)
                                })*/
                          });
                      });
                  });
              })
              .catch(function (error) {
                self.errorMessage = error.message;
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" >
.card {
  border: 0 solid rgba(34, 41, 47, 0.125);
  border-radius: 0.428rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.125);
}
.card-header {
  background-color: #fff;
}
.card-title {
  font-weight: 500;
  font-size: 1.285rem;
  margin-bottom: 0px;
}
.form__email {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  &:focus-within {
    border-color: #7367f0;
    box-shadow: none;
  }
}

.form-control.input__password,
.form-control.input__email {
  display: block;
  width: 100%;
  padding: 0.771rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  appearance: none;
  border-radius: 0.357rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.form__email:focus-within .form-control,
.form__email:focus-within .cursor__pointer {
  border-color: #7367f0;
  box-shadow: none;
}
.cursor__pointer {
  display: flex;
  align-items: center;
  padding: 0.571rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  border-left: none;
  cursor: pointer;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.fw-bolder {
  font-weight: 600 !important;
}
.ps-1 {
  padding-left: 1rem !important;
}
.ms-25 {
  margin-left: 0.25rem !important;
}
.btn__save {
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.358rem;
  border-color: #7367f0 !important;
  background-color: #7367f0 !important;
  color: #fff !important;
}
.btn__discard {
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.358rem;
  border: 1px solid #82868b !important;
  background-color: transparent;
  color: #82868b;
}
.btn__delete {
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.358rem;
  border-color: #ea5455 !important;
  background-color: #ea5455 !important;
  color: #fff !important;
}
.alert-warning {
  background: rgba(255, 159, 67, 0.12) !important;
  color: #ff9f43 !important;
}
.alert.alert-danger,
.alert.alert-success {
  width: 50%;
  margin-top: 10px;
  align-self: center;
}
.div__save {
  text-align-last: center;
}
</style>


// WEBPACK FOOTER //
// src/views/user_profile/info/email.vue